import { useCurrentCloudProvider } from '@labrav/common'
import React from 'react'
import {
  BoxV2,
  CheckBoxFieldv2,
  RadioButtonType,
  RadioButtonsV2,
} from '@labrav/react-components'
import { FormikProps, useFormikContext } from 'formik'
import {
  FlyOutProductTerm,
  FlyoutProductAddEditSectionName,
  FlyoutProductSections,
} from '../../../types/addEditProduct'
import { useStyles } from './FlyOutProductAdhere.styles'
import clsx from 'clsx'
import { Typography } from '@mui/material'
import { get, isEmpty } from 'lodash'
import { FormLockedType } from '../../../types/FormLockedType'
import { FlyoutProductDetailsAcknowledgementFaqs } from './FlyoutProductAdhereFaqs'
import { CloudType } from '../../../types/index'

interface FlyOutOnboardingAdhereProps {
  requirementsLink?: string
  sectionName: FlyoutProductAddEditSectionName
}

export const FlyOutProductAdhere: React.FC<
  FlyOutOnboardingAdhereProps & FormLockedType
> = ({ sectionName, isFormLocked }) => {
  const { values, errors, touched, handleChange, setFieldValue } =
    useFormikContext() as FormikProps<FlyoutProductSections>
  const selectedCloud = useCurrentCloudProvider()
  const termsAndConditions = get(
    values?.termsAndConditions,
    `${sectionName}`,
    []
  ) as FlyOutProductTerm[]

  const termsAndConditionsError = get(
    errors?.termsAndConditions,
    `${sectionName}`,
    []
  ) as FlyOutProductTerm[]

  const termsAndConditionsTouched = get(
    touched?.termsAndConditions,
    `${sectionName}`,
    []
  ) as FlyOutProductTerm[]

  const handleRadioChanges =
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setFieldValue(
        `termsAndConditions.${sectionName}.${index}.value`,
        event.target.value === 'Yes'
      )
      if (
        (isEmpty(event.target.value) || event.target.value === 'No') &&
        termsAndConditions[index].subTermsWhenTrue
      ) {
        setFieldValue(
          `termsAndConditions.${sectionName}.${index}.subTermsWhenTrue.value`,
          false
        )
      }
    }

  const { classes } = useStyles()
  return !isEmpty(termsAndConditions) ? (
    <BoxV2
      heading={
        <Typography className={classes.boxHeading}>
          I acknowledge the following:
        </Typography>
      }
      {...(selectedCloud === CloudType.AWS && {
        secondaryActions: <FlyoutProductDetailsAcknowledgementFaqs />,
      })}
    >
      <div
        className={clsx(classes.labelText, classes.container)}
        data-testid={`field-${sectionName}-adhere`}
      >
        {termsAndConditions.map((term, index) => (
          <div>
            {term.type === 'checkbox' ? (
              <CheckBoxFieldv2
                keyName={`termsAndConditions.${sectionName}.${index}.value`}
                title={term.label}
                value={term.value}
                onChangeBox={handleChange}
                disabled={isFormLocked}
              />
            ) : (
              <div className={classes.radioContainer}>
                <Typography className={classes.radioLabel}>
                  {term.label}
                </Typography>
                <div className={classes.textWidth}>
                  <RadioButtonsV2
                    name={`termsAndConditions.${sectionName}.${index}.value`}
                    checkedValue={{
                      key: term.value ? 'Yes' : 'No',
                      value: term.value ? 'Yes' : 'No',
                    }}
                    handleChange={handleRadioChanges(index)}
                    radioButtonMappings={[
                      {
                        key: 'Yes',
                        label: 'Yes',
                        type: RadioButtonType.STANDARD,
                        disabled: isFormLocked,
                      },
                      {
                        key: 'No',
                        label: 'No',
                        type: RadioButtonType.STANDARD,
                        disabled: isFormLocked,
                      },
                    ]}
                  />
                </div>
                <div>
                  {term.subTermsWhenTrue && term.value ? (
                    <div
                      className={classes.subTerms}
                      data-testid={`subTerms-${index}`}
                    >
                      <CheckBoxFieldv2
                        keyName={`termsAndConditions.${sectionName}.${index}.subTermsWhenTrue.value`}
                        title={term.subTermsWhenTrue.label}
                        value={term.subTermsWhenTrue.value}
                        onChangeBox={handleChange}
                        disabled={isFormLocked}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                {term.subTermsWhenTrue &&
                  term.value &&
                  termsAndConditionsTouched?.[index]?.subTermsWhenTrue?.value &&
                  termsAndConditionsError?.[index]?.subTermsWhenTrue?.value && (
                    <div className={classes.errorMessage}>
                      {/* {termsAndConditionsError[index].value} */}
                      {(!!termsAndConditionsTouched?.[index]?.subTermsWhenTrue
                        ?.value &&
                        termsAndConditionsError?.[index]?.subTermsWhenTrue
                          ?.value) ||
                        ''}
                    </div>
                  )}
              </div>
            )}
          </div>
        ))}
      </div>
      {termsAndConditionsTouched?.length > 0 &&
        termsAndConditionsError?.length > 0 && (
          <div className={classes.errorMessage}>
            {termsAndConditionsError?.find(item => item && item?.value)?.value}
          </div>
        )}
    </BoxV2>
  ) : (
    <></>
  )
}
